import reducers from "./reducers/index";
import { legacy_createStore as createStore, applyMiddleware } from "redux";
import { thunk } from "redux-thunk";
import { persistReducer, persistStore } from "redux-persist";
// import storage from "redux-persist/lib/storage";
import createIndexedDBStorage from "redux-persist-indexeddb-storage";
import { migrate } from "./migrations";

const persistConfig = {
  key: "chathub-store",
  version: 2,
  // storage,
  storage: createIndexedDBStorage(),
  migrate // Switching to IndexedDB storage
};

const middleware = [thunk];

const persistedReducer = persistReducer(persistConfig, reducers);

const store = createStore(persistedReducer, applyMiddleware(...middleware));

export const persistor = persistStore(store);

export default store;